/**
 * Use prefix 200 for OPS NAVI CM access right
 * For example 1009, the original access right id = 9
 */

export const OPS_NAVI_CM_ACR_PREFIX = 200;

export const combineOpsNaviCMACRWithPrefix = (acrId: number) => {
  return Number(`${OPS_NAVI_CM_ACR_PREFIX}${acrId}`);
};

export const BU_ACCESS_RIGHT = {
  ASSIGN_STAFF: combineOpsNaviCMACRWithPrefix(1),
  ALL_MEMBER_MANAGEMENT: combineOpsNaviCMACRWithPrefix(2),
  EDIT_OTHER_MEMBER_MANAGEMENT: combineOpsNaviCMACRWithPrefix(7),
  EDIT_ROLE_NAME: combineOpsNaviCMACRWithPrefix(8),
  ADD_CREATE_BU_MEMBER: combineOpsNaviCMACRWithPrefix(9),
  REMOVE_BU_MEMBER: combineOpsNaviCMACRWithPrefix(10),
  ALL_GENERAL_SETTING: combineOpsNaviCMACRWithPrefix(3),
  EDIT_OTHER_GENERAL_SETTING: combineOpsNaviCMACRWithPrefix(11),
  EDIT_BU_GENERAL_SETTING: combineOpsNaviCMACRWithPrefix(12),
  DELETE_BU: combineOpsNaviCMACRWithPrefix(13),
  MANAGE_JOB_DOCUMENT: combineOpsNaviCMACRWithPrefix(4),
  ALL_BU_APP_MANAGEMENT: combineOpsNaviCMACRWithPrefix(5),
  EDIT_ORHTER_MEMBER_BU_APP_MANAGEMENT: combineOpsNaviCMACRWithPrefix(14),
  ACCESS_APP: combineOpsNaviCMACRWithPrefix(15),
  LEAVE_BU: combineOpsNaviCMACRWithPrefix(6),
};

export const APP_ACCESS_RIGHT = {
  ALL_PERMISSIONS_FOR_THIS_APP: 1, // All permissions for this app
  AI_MATCHING: 2, // AI matching
  AI_MATCHING_EDIT_ACR_FOR: 10, // Able to edit ACR for AI matching
  AI_MATCHING_VIEW: 11, // Able to read/view AI matching
  KANBAN: 3, // Kanban
  KANBAN_EDIT_ACR: 12, // Able to edit ACR
  KANBAN_CREATE_STAFF_TICKET: 13, // Create staff ticket
  KANBAN_CREATE_CLIENT_TICKET: 14, // Create client ticket
  KANBAN_CREATE_MATCH_TICKET: 15, // Create match ticket
  KANBAN_CREATE_AD_HOC_TICKET: 16, // Create ad hoc ticket
  KANBAN_READ_ALL_STAFF_TICKETS: 17, // Read all staff tickets
  KANBAN_READ_ALL_CLIENT_TICKETS: 18, // Read all client tiCreate client ticketckets
  KANBAN_READ_ALL_MATCH_TICKETS: 19, // Read all match tickets
  KANBAN_READ_ALL_AD_HOC_TICKETS: 20, // Read all ad hoc tickets
  KANBAN_READ_ASSIGNED_STAFF_TICKETS: 21, // Read only assigned staff tickets
  KANBAN_READ_ASSIGNED_CLIENT_TICKETS: 22, // Read only assigned client tickets
  KANBAN_READ_ASSIGNED_MATCH_TICKETS: 23, // Read only assigned match tickets
  KANBAN_READ_ASSIGNED_AD_HOC_TICKETS: 24, // Read only assigned ad hoc tickets
  KANBAN_READ_LINKED_ASSIGNED_TICKETS: 25, // Read only linked tickets which are assigned
  KANBAN_EDIT_STAFF_TICKETS: 26, // Edit staff tickets
  KANBAN_EDIT_ASSIGNED_STAFF_TICKETS: 27, // Edit only assigned staff tickets
  KANBAN_EDIT_CLIENT_TICKETS: 28, // Edit client tickets
  KANBAN_EDIT_ASSIGNED_CLIENT_TICKETS: 29, // Edit only assigned client tickets
  KANBAN_EDIT_MATCH_TICKETS: 30, // Edit match tickets
  KANBAN_EDIT_ASSIGNED_MATCH_TICKETS: 31, // Edit only assigned match tickets
  KANBAN_EDIT_AD_HOC_TICKETS: 32, // Edit ad hoc tickets
  KANBAN_EDIT_ASSIGNED_AD_HOC_TICKETS: 33, // Edit only assigned ad hoc tickets
  KANBAN_DELETE_STAFF_TICKETS: 34, // Delete (archive) staff tickets
  KANBAN_DELETE_ASSIGNED_STAFF_TICKETS: 35, // Delete (archive) only assigned staff tickets
  KANBAN_DELETE_CLIENT_TICKETS: 36, // Delete (archive) client tickets
  KANBAN_DELETE_ASSIGNED_CLIENT_TICKETS: 37, // Delete (archive) only assigned client tickets
  KANBAN_DELETE_MATCH_TICKETS: 38, // Delete (archive) match tickets
  KANBAN_DELETE_ASSIGNED_MATCH_TICKETS: 39, // Delete (archive) only assigned match tickets
  KANBAN_DELETE_AD_HOC_TICKETS: 40, // Delete (archive) ad hoc tickets
  KANBAN_DELETE_ASSIGNED_AD_HOC_TICKETS: 41, // Delete (archive) only assigned ad hoc tickets
  SCORE_CARD: 4, // Score card
  SCORE_CARD_SCORE_CARD_EDIT_ACR: 42, // Able to edit ACR
  SCORE_CARD_CREATE_SCORE_CARDS: 43, // Create score cards
  SCORE_CARD_READ_ALL_SCORE_CARDS: 44, // Read all score cards
  SCORE_CARD_READ_ASSIGNED_SCORE_CARDS: 45, // Read only assigned score cards
  SCORE_CARD_EDIT_ALL_SCORE_CARDS: 46, // Edit all score cards
  SCORE_CARD_EDIT_ASSIGNED_SCORE_CARDS: 47, // Edit only assigned score cards
  SCORE_CARD_DELETE_ALL_SCORE_CARDS: 48, // Delete all score cards
  SCORE_CARD_DELETE_ASSIGNED_SCORE_CARDS: 49, // Delete only assigned score cards
  EOD: 5, // EOD
  EOD_EDIT_ACR_FOR_EOD: 50, // Able to edit ACR for EOD
  EOD_MANAGE_ALL_EOD: 51, // Able to manage all of EOD
  EOD_MANAGE_PAST_DUE_EOD: 52, // Able to manage past due date EOD
  EOD_MANAGE_ASSIGNED_EODS: 53, // Only able to manage EODs which are assigned
  OPSNAVI_MEMBER_MANAGEMENT: 6, // OpsNavi member management
  OPSNAVI_MEMBER_MANAGEMENT_EDIT_ACR: 54, // Able to edit ACR
  OPSNAVI_MEMBER_MANAGEMENT_APPROVE_OPSNAVI_MEMBER: 55, // Approve OpsNavi member
  OPSNAVI_MEMBER_MANAGEMENT_INVITE_OPSNAVI_MEMBER: 56, // Invite OpsNavi member
  OPSNAVI_MEMBER_MANAGEMENT_DELETE_OPSNAVI_MEMBER: 57, // Delete OpsNavi member
  CONVERSION: 7, // Conversion
  CONVERSION_EDIT_ACR: 58, // Able to edit ACR
  CONVERSION_INPUT_CONVERSION: 59, // Able to input conversion
  CONVERSION_READ_CONVERSION: 60, // Able to read conversion
  CONVERSION_EDIT_CONVERSION_SUGGESTION_MODE: 61, // Able to edit (suggestion mode) conversion
  CONVERSION_DELETE_CONVERSION: 62, // Able to delete conversion
  INTERVIEW: 8, // Interview
  INTERVIEW_EDIT_ACR: 63, // Able to edit ACR
  INTERVIEW_CREATE_INTERVIEW_FOR_ASSIGNED_PA: 64, // Able to create interview for assigned PA
  INTERVIEW_READ_ALL_INTERVIEWS_WITHIN_BU: 65, // Able to read all interview within BU
  INTERVIEW_EDIT_INTERVIEWS_SUGGESTION_MODE_ASSIGNED_PA: 66, // Able to edit (suggestion mode) interviews for assigned PA
  INTERVIEW_READ_INTERVIEWS_ASSIGNED_PA: 67, // Able to read interviews for assigned PA
  INTERVIEW_DELETE_ALL_INTERVIEWS_WITHIN_BU: 68, // Able to delete all interview within BU
  INTERVIEW_DELETE_INTERVIEWS_ASSIGNED_PA: 69, // Able to delete interviews for assigned PA
  TAGS: 9, // Tags
  TAGS_EDIT_ACR: 70, // Able to edit ACR
  TAGS_CREATE_TAGS: 71, // Able to create tags
  TAGS_VIEW_TAGS: 72, // Able to view tags
  TAGS_EDIT_TAGS: 73, // Able to edit tags
  TAGS_DELETE_TAGS: 74, // Able to delete tags
};

export const APP_ACCESS_RIGHT_EDIT_SECTION_ID = {
  [APP_ACCESS_RIGHT.ALL_PERMISSIONS_FOR_THIS_APP]:
    APP_ACCESS_RIGHT.ALL_PERMISSIONS_FOR_THIS_APP,
  [APP_ACCESS_RIGHT.AI_MATCHING]: APP_ACCESS_RIGHT.AI_MATCHING_EDIT_ACR_FOR,
  [APP_ACCESS_RIGHT.KANBAN]: APP_ACCESS_RIGHT.KANBAN_EDIT_ACR,
  [APP_ACCESS_RIGHT.SCORE_CARD]:
    APP_ACCESS_RIGHT.SCORE_CARD_SCORE_CARD_EDIT_ACR,
  [APP_ACCESS_RIGHT.EOD]: APP_ACCESS_RIGHT.EOD_EDIT_ACR_FOR_EOD,
  [APP_ACCESS_RIGHT.OPSNAVI_MEMBER_MANAGEMENT]:
    APP_ACCESS_RIGHT.OPSNAVI_MEMBER_MANAGEMENT_EDIT_ACR,
  [APP_ACCESS_RIGHT.CONVERSION]: APP_ACCESS_RIGHT.CONVERSION_EDIT_ACR,
  [APP_ACCESS_RIGHT.INTERVIEW]: APP_ACCESS_RIGHT.INTERVIEW_EDIT_ACR,
  [APP_ACCESS_RIGHT.TAGS]: APP_ACCESS_RIGHT.TAGS_EDIT_ACR,
};
